import React from 'react';
import HighlightAction from '../../actions/highlight-action';
import { Button, TextField, Form } from "@vitalsource/vstui";

var Isvg = require('../../../vendor/react-inlinesvg');

class ManageSubscriptions extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      failure: false,
      myFollowers: props.myFollowers,
      showEnterEmail: false,
      followingMessage: "",
      newSubscriptionEmail: ""
    };

    this._updateSubscriptionEmail = this._updateSubscriptionEmail.bind(this);
    this._getUserSubscriptions = this._getUserSubscriptions.bind(this);
    this._toggleFollowingEmail = this._toggleFollowingEmail.bind(this);
    this._stopAddingSubscription = this._stopAddingSubscription.bind(this);
    this._checkEmailExistence = this._checkEmailExistence.bind(this);
    this._addSubscription = this._addSubscription.bind(this);
    this._deleteSubscription = this._deleteSubscription.bind(this);
    this._resetHighlights = this._resetHighlights.bind(this);
    this._scrollToSubscription = this._scrollToSubscription.bind(this);

    this.followingEmailRef = React.createRef();
  }

  componentDidMount() {
    this.onKeyUp = e => e.stopPropagation();
    this._getUserSubscriptions();
  }

  componentWillUnmount() {
    document.getElementById("followingEmail").removeEventListener('keyup', this.onKeyUp);
  }

  _updateSubscriptionEmail(e) {
    this.setState({newSubscriptionEmail: e.currentTarget.value, failure: false});
  }

  _getUserSubscriptions(callback) {
    Fraction.Helpers.addLoader(".manage-following");
    Fraction.Helpers.addLoader(".null-screen");
    Jigsaw.User.getFollowings((response) => {
      if (response.isSuccess()){
        Fraction.Helpers.removeLoader(".manage-following");
        Fraction.Helpers.removeLoader(".null-screen");

        var sortedSubscriptions = response.data.user.sort((a,b) => { return (a.full_name > b.full_name ? 1 : (a.full_name < b.full_name ? -1 : 0)); });
        if (response.data.user.length === 0) {
          this.setState({showEnterEmail: true});
        }
        this.setState({subscriptions: sortedSubscriptions});
        if (callback){ callback(); }
      } else if (response.data.code===401) {
        Fraction.Helpers.signin();
      } else {
        Fraction.Helpers.removeLoader(".manage-following");
        Fraction.Helpers.removeLoader(".null-screen");
        this.setState({unavailable: true});
      }
    });
  }

  _toggleFollowingEmail() {
    const followingEmailShow = this.state.showEnterEmail;
    if (followingEmailShow) {
      this.setState({showEnterEmail: false, failure: false}, () => {
        document.getElementById("followingEmail").removeEventListener('keyup', this.onKeyUp);
      });
    } else {
      this.setState({showEnterEmail: true, newSubscriptionEmail: "", failure: false}, () => {
        document.getElementById("followingEmail").addEventListener('keyup', this.onKeyUp);
      });
    }
  }

  _stopAddingSubscription(e) {
    e.preventDefault();
    e.stopPropagation();
    $("#enterEmail").focus();
    this.setState({creatingNewSubscription: false, showEnterEmail: false});
    Fraction.Reporter.gaEvent("sharing/subscriptions/cancel-adding-subscription");
    return false;
  }

  _checkEmailExistence(email) {
    for (var i=0;i < this.state.subscriptions.length;i++){
      if (Fraction.User.email.toLowerCase()===email.toLowerCase()){
        this.setState({failure: true});
        return true;
      }
    }
    return false;
  }

  _addSubscription(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.state.newSubscriptionEmail && this.state.newSubscriptionEmail.length>0){
      if (!this._checkEmailExistence(this.state.newSubscriptionEmail)){
        Fraction.Helpers.addLoader(".following-form");
        Jigsaw.User.subscribeTo(this.state.newSubscriptionEmail, (response) => {
            Fraction.Helpers.removeLoader(".following-form");
            if (response.isSuccess()){
              var size = this.state.subscriptions.length;
              this._getUserSubscriptions(() => {
                if (this.state.subscriptions.length===size){
                  this.setState({failure: true, followingMessage: i18n.t("sharing.following-already-following")});
                  $(".following-email").focus();
                } else {
                  $("#enterEmail").focus();
                  this.setState({flashEmail: this.state.newSubscriptionEmail, creatingNewSubscription: false, showEnterEmail: false});
                  this._resetHighlights();
                  this._stopAddingSubscription();
                }
              });
              this._resetHighlights();
            } else if (response.data.code === 401) {
              // Unauthorized
              Fraction.Helpers.signin();
            } else if (response.data.code === 422) {
              this.setState({failure: true, followingMessage: i18n.t("sharing.following-no-account")});
            } else {
              this.setState({failure: true, followingMessage: i18n.t("sharing.following-invalid-email")});
            }
          }
        );
        Fraction.Reporter.gaEvent("sharing/subscriptions/add-subscription");
      }
    } else {
      this.setState({failure: true, followingMessage: i18n.t("sharing.following-empty-email")}, () => {});
    }
    return false;
  }

  _deleteSubscription(e) {
    var guid = $(e.currentTarget).data('guid');
    if (guid){
      Fraction.Helpers.addLoader(".following-list");
      Jigsaw.User.unfollow(guid, (response) => {
        Fraction.Helpers.removeLoader(".following-list");
        this._getUserSubscriptions();
        this._resetHighlights();
        Fraction.Reporter.gaEvent("sharing/subscriptions/delete-subscription");
      });
    }
  }

  _resetHighlights() {
    HighlightAction.resetHighlights(this.props.isbn);
  }

  _scrollToSubscription(element) {
    if (element){
      var scrollTo = element.offsetTop-10;
      if ((element.offsetTop+$(element).innerHeight()+10)>($(".manage-following").scrollTop()+$(".manage-following").innerHeight())){
        scrollTo = element.offsetTop - $(".manage-following").innerHeight() + $(element).innerHeight() + 10;
        $(".manage-following").animate({
          scrollTop: scrollTo
        }, 500, 'swing');
      }
    }
  }

  render() {
    // adding subscription form
    var subscriptionForm = <span />;
    var shouldShowEnterEmail = Fraction.Brand.Sharing.subscribeViaEmail && this.state.showEnterEmail;
    var emailInputContainerStyles = (shouldShowEnterEmail) ? {display: 'block'} : {display: 'none'};
    subscriptionForm = (
      <form className="following-form" onSubmit={this._addSubscription}>
        <div className="input-container">
          <TextField label={i18n.t('base.email')}
                    id="followingEmail"
                    className={"following-email"}
                    ref={this.followingEmailRef}
                    fullWidth
                    value={this.state.newSubscriptionEmail}
                    onChange={this._updateSubscriptionEmail} type="email"/>
        </div>
        <div className="action-options">
          <Button id="cancelEnterEmail" naked className="submit noButton cancel linkGray" size="small" onClick={this._stopAddingSubscription}>
            {i18n.t("base.cancel")}
          </Button>
          <Button id="addEnterEmail" className="submit save" size="small">
            {i18n.t("base.add")}
          </Button>
        </div>
      </form>);

    var subscriptionList = <span />;
    if ((this.state.subscriptions && this.state.subscriptions.length>0) || this.state.creatingNewSubscription){
      if (!Fraction.Helpers.isSmallScreen() || !this.state.creatingNewSubscription){
        subscriptionList =
          <ul className="following-list noList">
            {this.state.subscriptions.map((subscription, i) => {
              return (
                <li key={subscription.id} data-globalid={subscription.id} className={this.state.flashEmail===subscription.id ? "flash" : ""}>
                  <div data-index={i} className="single-subscription">
                    <span className="subscription-name">{subscription.full_name}</span>
                    {Fraction.Brand.Sharing.showUnsubscribe && 
                      <button id={"unfollowUser"+i} 
                              className="subscription-delete noButton" 
                              data-index={i} data-guid={subscription.id} 
                              onClick={this._deleteSubscription} 
                              onTouchEnd={this._deleteSubscription}>
                        <span>{i18n.t("sharing.unfollow")}</span>
                      </button>
                    }
                  </div>
                </li>
              );
            })}
          </ul>;
      }
    } else {
      if (!this.state.unavailable) { // notes server is up!
        subscriptionList =
          <div className="null-screen">
            <Isvg className="watkins" src="/img/sharing_empty_state.svg" />
            <div>{window.toHTML(i18n.t('sharing.not-following-user'))}</div>
          </div>;
      } else { // notes server is :(
        subscriptionList =
          <div className="null-screen">
            {Fraction.Brand.Graphics.watkins ?
              <Isvg className="watkins" src="/img/prop_laptop_no.svg" /> :
              <Isvg className="watkins null" src="" />
            }
            <div>{i18n.t('reader.notebook.notes-info-error')}</div>
          </div>;
      }
    }
    return (
      <div className="manage-following" role="tabpanel">
        <div className="description">
          {window.toHTML(i18n.t('sharing.following-description'))}
          {Fraction.Brand.Sharing.subscribeViaEmail &&
            <div>
            {i18n.tsx(
              'sharing.following-description-email',
              {
                enterEmail: <Button
                  id="enterEmail"
                  inline
                  naked
                  aria-expanded={shouldShowEnterEmail}
                  onClick={this._toggleFollowingEmail}
                  label={i18n.t('sharing.following-enter-email-label')}
                >
                  {i18n.t('sharing.enter-email')}
                </Button>
              })}
            </div>
          }
        </div>
        <div className="add-following" style={emailInputContainerStyles}>
          {subscriptionForm}
        </div>
        {subscriptionList}
      </div>
    );
  }

};

export default ManageSubscriptions;
